import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found-component',
  templateUrl: './notFound.component.html',
  styleUrls: ['./notFound.component.scss'],
})
export class NotFoundComponent {}



// WEBPACK FOOTER //
// ./src/app/common/components/NotFoundComponent/notFound.component.ts